import { type StringIndexedObject, useForm } from '@kanda-libs/ks-component-ts';
import { FirebaseAuthService, actions } from '@kanda-libs/ks-frontend-services';
import { useAppDispatch } from 'components/App';
import useApiError from 'hooks/useApiError';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectors } from 'store';

export interface StaffImitationHook {
  form: ReturnType<typeof useForm>;
  onSubmit: (args: StringIndexedObject) => void;
  isSubmitting: boolean;
}

/**
 * Returns current job and loading state\
 * @return {Object}
 */
export default function useStaffImitation(): StaffImitationHook {
  const dispatch = useAppDispatch();
  const form = useForm({ mode: 'onBlur' });
  const isSubmitting = useSelector(selectors.infoGhost.getIsSubmitting);

  const onError = useApiError('There was an error logging in as this user');

  const onSubmit = useCallback(
    (formData: StringIndexedObject) => {
      const { email } = formData;
      if (!email) return;

      dispatch(
        actions.infoGhost({
          body: {
            email,
          },
          onError,
          onSuccess: (data) => {
            FirebaseAuthService.signInWithCustomToken(
              data?.custom_token as string,
              false,
            );

            setTimeout(() => {
              window.location.href = '/';
            }, 1000);
          },
        }),
      );
    },
    [dispatch, onError],
  );

  return { form, onSubmit, isSubmitting: !!isSubmitting };
}
